import { useEffect } from "react";
import { notifyStoreParent } from "@utils";
import { getExternalBankFailureUrl } from "./flowRouting";

export const useFlowRouting = ({
  flowId,
  id,
  routeId,
  paymentParameters,
  methodStepData,
  navigate,
}) => {
  useEffect(() => {
    if (!paymentParameters) return;

    const basePath = `/${flowId}/${id}`;
    const externalSuccessUrl = paymentParameters?.successUrl;
    const externalCancelUrl = paymentParameters?.cancelUrl;
    const externalBankFailureUrl = getExternalBankFailureUrl({
      flowId,
      status: paymentParameters?.status,
      cancelUrl: externalCancelUrl,
      search: window.location.search,
    });

    if (
      (paymentParameters.paidOn || paymentParameters.amountPaid) &&
      routeId !== `${flowId}-success`
    ) {
      if (externalSuccessUrl) {
        // An embedding store that gave us its origin handles the return
        // itself from this message. Navigating the iframe as well would race
        // the store's own top-level navigation with a cookieless request.
        const storeHandlesReturn = notifyStoreParent({
          type: "ontik:hosted:payment_success",
          redirectUrl: externalSuccessUrl,
        });
        if (!storeHandlesReturn) {
          window.location.href = externalSuccessUrl;
        }
      } else {
        navigate(`${basePath}/success`);
      }
    } else if (externalBankFailureUrl) {
      // As with success: a store that owns the return navigates its own
      // top-level page from this message. Navigating the iframe as well sends
      // the shopper through the store's cancel URL twice.
      if (!notifyStoreParent({ type: "ontik:hosted:cancel" })) {
        window.location.replace(externalBankFailureUrl);
      }
    } else if (
      paymentParameters?.status === "PaymentFailed" &&
      routeId === `${flowId}-processing`
    ) {
      navigate(`${basePath}/paymentfailed`);
    } else if (
      (paymentParameters?.status === "Cancelled" ||
        paymentParameters?.status === "Expired") &&
      routeId !== `${flowId}-cancelled`
    ) {
      if (externalCancelUrl) {
        if (!notifyStoreParent({ type: "ontik:hosted:cancel" })) {
          window.location.href = externalCancelUrl;
        }
      } else {
        navigate(`${basePath}/cancelled`);
      }
    } else if (
      (paymentParameters?.status === "PaymentProcessing" ||
        paymentParameters?.status === "Processing") &&
      routeId !== `${flowId}-processing`
    ) {
      navigate(`${basePath}/processing`);
    } else if (
      routeId === `${flowId}-confirmpaybybank` &&
      (!methodStepData || !methodStepData.institution)
    ) {
      navigate(`${basePath}/paymentmethod`);
    } else if (
      flowId === "pay" &&
      routeId === `${flowId}-base` &&
      paymentParameters.statement
    ) {
      navigate(`${basePath}/selectinvoices`);
    } else if (
      routeId === `${flowId}-paybycard` &&
      !paymentParameters.cardPaymentAllowed
    ) {
      navigate(`${basePath}/paymentmethod`);
    } else if (
      routeId === `${flowId}-paybybnpl` &&
      !paymentParameters.klarnaPaymentAllowed
    ) {
      navigate(`${basePath}/paymentmethod`);
    } else if (
      (routeId === `${flowId}-paybybank` ||
        routeId === `${flowId}-confirmpaybybank`) &&
      !paymentParameters.openBankingPaymentAllowed
    ) {
      navigate(`${basePath}/paymentmethod`);
    }
  }, [flowId, id, routeId, paymentParameters, methodStepData, navigate]);
};
